<script>
    import Tooltip from "../Tooltip.svelte";
    import Duracion from "../Duracion.svelte";

    export let barra;

    let tooltip;
</script>

<style>
    .barra {
        --color: var(--negro);
        position: absolute;
        top: 0;
        height: 100%;
        background: var(--verde);
    }

    .hora, .duracion {
        font-size: .9em;
        white-space: nowrap;
    }
</style>

<div class="barra" style="left: {barra.inicio}%; width: {barra.longitud}%" tabindex="0"
     on:focus={() => tooltip = true} on:blur={() => tooltip = false}
     on:mouseover={() => tooltip = true} on:mouseleave={() => tooltip = false}>
    {#if tooltip}
        <Tooltip>
            <div class="hora">
                {barra.entrada} – {barra.salida}
            </div>
            <div class="duracion">
                <Duracion minutos={barra.duracion} />
            </div>
        </Tooltip>
    {/if}
</div>